<template>
    <div name="soldoc-review" class="soldoc-review">
        <div class="inner-div">
            <span class="d-title">생생한 후기를 확인하세요</span>
            <span class="d-sub-title">솔닥을 먼저 경험한 고객님들의 생생한 후기를 만나보세요</span>
        </div>
        <div class="inner-div2">
			<div class="slider-container">
				<div class="slider-area">
					<div
						class="slider-wrapper"
						:style="{ transform: transformStyle }"
					>
						<div
							class="review-card"
							v-for="card in cards" :key="card.id"
						>
							<div class="header-area">
								<img :src="card.icon" :alt="card.iconalt" />
								<div class="title-area">
									<div class="category">{{ card.category }}</div>
									<div class="tag" :class="card.tagClass">{{ card.tag }}</div>
								</div>
							</div>
							<p class="content-area">{{ card.content }}</p>
							<div class="footer-area">{{ card.hospital }}</div>
						</div>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'soldoc-review',
    data: function(){
        return{
            flag: false,
            dupClick: false,
            order: 1,
            left: false,
			currentIndex: 1,
			originalCards: [
				{
				id: 0,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconalt :'20대 남성 바로솔닥',
				category: '20대 남성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '이전에는 병원 찾기부터 예약, 결제, 서류 발급 등 복잡한 과정을 거쳐야 했지만, 바로솔닥을 이용하고 그런 과정을 크게 줄일 수 있었습니다.',
				hospital: '가정의학과 진료'
				},
				{
				id: 1,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconalt :'40대 여성 바로솔닥',
				category: '40대 여성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '바쁜 일상에서 원하는 시간에 병원 예약을 할 수 있다는 점이 감동적입니다. 이제는 건강관리를 위한 시간과 공간의 제약을 걱정하지 않아도 돼요.',
				hospital: '이비인후과 진료'
				},
				{
				id: 2,
				icon: require('../../assets/renew_pc/ico_review02.png'),
				iconalt :'50대 남성 바로돌봄',
				category: '50대 남성',
				tag: '바로돌봄',
				tagClass: 'tag02',
				content: '어머님 모시고 병원 갈 때마다 연차 쓰고 1시간 이상은 병원에서 대기했는데 기다림 없이 진료 볼 수 있어서 너무 편합니다.',
				hospital: '주야간보호센터'
				},
				{
				id: 3,
				icon: require('../../assets/renew_pc/ico_review03.png'),
				iconalt :'30대 여성 솔닥파트너스',
				category: '30대 여성',
				tag: '솔닥파트너스',
				tagClass: 'tag03',
				content: '솔닥으로 만나는 환자들 진료를 전용 EMR로 쉽게 관리할 수 있어서 좋습니다.',
				hospital: '피부과 의사'
				},
				{
				id: 4,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconalt :'30대 여성 바로솔닥',
				category: '30대 여성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '바로솔닥을 통해 병원 찾기부터 예약, 결제, 조제약 수령, 서류 발급까지 모든 과정이 편리해졌습니다. 건강 관리에 대한 새로운 패러다임이에요.',
				hospital: '피부과 진료'
				},
				{
				id: 5,
				icon: require('../../assets/renew_pc/ico_review02.png'),
				iconalt :'70대 여성 바로돌봄',
				category: '70대 여성',
				tag: '바로돌봄',
				tagClass: 'tag02',
				content: '원장님을 편하게 자주 보고 진료받을 수 있어서좋습니다. 항상 친절하게 상세하게 물어봐주셔서 무척 감동했어요.',
				hospital: '주야간보호센터'
				},
				{
				id: 6,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconalt :'40대 남성 바로솔닥',
				category: '40대 남성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '바로솔닥으로 진료 예약부터 서류 발급까지 편리하게 이루어져서 정말 만족스럽습니다. 이제 기다릴 필요가 없어서 너무 편해요.',
				hospital: '내과 진료'
				},
				{
				id: 7,
				icon: require('../../assets/renew_pc/ico_review03.png'),
				iconalt :'40대 남성 솔닥파트너스',
				category: '40대 남성',
				tag: '솔닥파트너스',
				tagClass: 'tag03',
				content: '비대면진료뿐 아니라 대면진료, 요양기관 진료도 가능해서 환자들과의 접점을 늘릴 수 있는 좋은 기회를 얻었습니다.',
				hospital: '피부과 의사'
				},
				{
				id: 8,
				icon: require('../../assets/renew_pc/ico_review02.png'),
				iconalt :'40대 남성 바로돌봄',
				category: '40대 남성',
				tag: '바로돌봄',
				tagClass: 'tag02',
				content: '보호자분들의 만족도가 굉장히 높습니다. 어르신 모시고 병원 방문하던 일들이 없어지며 효율이 증가합니다.',
				hospital: '주야간보호센터 센터장'
				},
				{
				id: 9,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconalt :'20대 여성 바로솔닥',
				category: '20대 여성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '내가 원하는 시간을 지정해서 병원을 방문할 수 있어서 만족스럽습니다. 회사에 있더라도 시간 맞춰 진료를 보고 복귀할 수 있기 때문에 잘 이용할 것 같아요.',
				hospital: '이비인후과 진료'
				},
				{
				id: 10,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconalt :'30대 여성 바로솔닥',
				category: '30대 여성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '병원마다 일일이 전화해서 진료 가능한 증상을 문의하는 게 무척 번거로웠는데, 솔닥에서는 증상별로 진료 가능한 병원을 찾아볼 수 있어서 만족스럽습니다.',
				hospital: '피부과 진료'
				},
				{
				id: 11,
				icon: require('../../assets/renew_pc/ico_review02.png'),
				iconalt :'50대 남성 바로돌봄',
				category: '50대 남성',
				tag: '바로돌봄',
				tagClass: 'tag02',
				content: '신규 상담 오신 보호자분들께서 높은 관심을 보이십니다. 급한 설사, 변비도 진료 보고 약을 받아볼 수 있어 매우 만족합니다.',
				hospital: '주야간보호센터 센터장'
				},
				{
				id: 12,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconalt :'40대 여성 바로솔닥',
				category: '40대 여성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '예진지를 통해 의사선생님과 소통이 원활해졌고, 보다 정확한 진단을 받을 수 있었습니다.',
				hospital: '산부인과 진료'
				},
				{
				id: 13,
				icon: require('../../assets/renew_pc/ico_review03.png'),
				iconalt :'30대 남성 솔닥파트너스',
				category: '30대 남성',
				tag: '솔닥파트너스',
				tagClass: 'tag03',
				content: '환자 문의 응대 등과 같은 진료 외 업무는 솔닥 전담팀에서 직접 담당해 주셔서 의료진은 진료에만 집중할 수 있는 환경이 조성되는 것 같아요.',
				hospital: '피부과 의사'
				},				
			],
			currentTranslateX: 0,
			slideWidth: 370,
        }
    },
	computed: {
		cards() {
			return [
				...this.originalCards.map(card => ({...card, id: card.id + 0})),
				...this.originalCards.map(card => ({...card, id: card.id + 100})),
				...this.originalCards.map(card => ({...card, id: card.id + 200})),
				...this.originalCards.map(card => ({...card, id: card.id + 300}))
			];
		},
		transformStyle() {
        return `translateX(-${this.currentTranslateX}px)`;
    }
	},
    mounted: function()
    {
        $(window).scroll(function () {

			var height = $(document).scrollTop();
            var contTop = $('.soldoc-review').offset().top;

            var contHeight = height - contTop;
            var winHeight = $(window).height();
            var acviveHeight = contHeight + winHeight;
            
            if(acviveHeight <= 0)
            {
				$('.d-title').css('display', `none`);
                $('.d-sub-title').css('display', `none`);
				$('.slider-container').css('display', `none`);
            }
            else if(acviveHeight > 100 && acviveHeight <= 200)
            {
				$('.d-title').css('display', `inline-block`);
                $('.d-sub-title').css('display', `inline-block`);
				$('.slider-container').css('display', `flex`);
            }     
            else
            {
				$('.d-title').css('display', `inline-block`);
                $('.d-sub-title').css('display', `inline-block`);
				$('.slider-container').css('display', `flex`);
            }   
        })

	    this.animateSlider(); 
    },
    methods: {
		animateSlider() {
        this.currentTranslateX += 2;
        
        if (this.currentTranslateX >= (this.cards.length - 6) * this.slideWidth) {
            this.currentTranslateX = 0; 
        }

        requestAnimationFrame(this.animateSlider);
    },

		moveSlide() {
			this.currentIndex++;

			if (this.currentIndex === this.cards.length - 6) {
				this.currentIndex = 0;
			}
		},
        // leftClick: function(){
        //     if(!this.dupClick)
        //     {
        //         this.dupClick = true;
        //         this.flag = false;
        //         this.left = true;
        //         $('.card-element').css('transition', '.5s');
        //         var removeElement = $('.card-element').eq(0);
        //         $('.card-element').eq(0).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(1).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(2).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(3).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(4).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(5).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(6).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(7).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(8).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(9).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(10).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(11).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(12).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(13).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(14).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(15).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(16).css('transform', 'translateX(-339px)');
        //         $('.card-element').eq(17).css('transform', 'translateX(-339px)');
            
        //         var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend'; 
        //         var _this = this;  
              
        //         $('.card-element').one(transitionEnd, function(){     
        //             // alert("on transition end")       
        //             $('.card-element').css('transition', '0s');          
        //             // $('.card-element').eq(17).after($('.card-element').eq()); 
        //             $('.card-element').eq(17).after(removeElement);  
        //             $('.card-element').eq(0).css('transform', 'translateX(0)');
        //             $('.card-element').eq(1).css('transform', 'translateX(0)');
        //             $('.card-element').eq(2).css('transform', 'translateX(0)');
        //             $('.card-element').eq(3).css('transform', 'translateX(0)');
        //             $('.card-element').eq(4).css('transform', 'translateX(0)');
        //             $('.card-element').eq(5).css('transform', 'translateX(0)');  
        //             $('.card-element').eq(6).css('transform', 'translateX(0)');
        //             $('.card-element').eq(7).css('transform', 'translateX(0)');
        //             $('.card-element').eq(8).css('transform', 'translateX(0)');
        //             $('.card-element').eq(9).css('transform', 'translateX(0)');
        //             $('.card-element').eq(10).css('transform', 'translateX(0)');
        //             $('.card-element').eq(11).css('transform', 'translateX(0)');
        //             $('.card-element').eq(12).css('transform', 'translateX(0)');
        //             $('.card-element').eq(13).css('transform', 'translateX(0)');
        //             $('.card-element').eq(14).css('transform', 'translateX(0)');
        //             $('.card-element').eq(15).css('transform', 'translateX(0)');
        //             $('.card-element').eq(16).css('transform', 'translateX(0)');
        //             $('.card-element').eq(17).css('transform', 'translateX(0)');
                
        //             _this.dupClick = false;
        //         });
        //     }
        
        // },
        // rightClick: function(){
        //     if(!this.dupClick)
        //     {
        //         this.dupClick;
        //         this.flag = false;
        //         this.left = false;
        //         var removeElement = $('.card-element').last();
        //         $('.card-element').css('transition', '.5s');                   
        //         $('.card-element').eq(0).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(1).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(2).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(3).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(4).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(5).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(6).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(7).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(8).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(9).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(10).css('transform', 'translateX(339px');
        //         $('.card-element').eq(11).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(12).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(13).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(14).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(15).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(16).css('transform', 'translateX(339px)');
        //         $('.card-element').eq(17).css('transform', 'translateX(339px)');

        //         var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend'; 
        //         var _this = this;        
        //         $('.card-element').one(transitionEnd, function(){     
                        
        //                 $('.card-element').css('transition', '0s');     
                      
        //                 $('.card-element').eq(0).before(removeElement); 
        //                 $('.card-element').eq(0).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(1).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(2).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(3).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(4).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(5).css('transform', 'translateX(0)');  
        //                 $('.card-element').eq(6).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(7).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(8).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(9).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(10).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(11).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(12).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(13).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(14).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(15).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(16).css('transform', 'translateX(0)');
        //                 $('.card-element').eq(17).css('transform', 'translateX(0)');
        //                 // $('.card-element').eq(17).css('transform', 'translateX(1000px)');
        //                 // $('.card').css('transform', 'translate(-77%, -50%)');  
                    
        //             _this.dupClick = false;
        //         });
        //     }
        // }
    }
}
</script>

<style scoped>
    .soldoc-review{
        min-width: 1200px;
        height: 968px;
        background: #F3F4F7;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        position: relative;
    }
    .inner-div{
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 1200px;
        height: 475px;
    }
    .inner-div2{
        position: absolute;
        left: 0px;
        top: 367px;
        display: flex;
		justify-content: center;
        align-items: flex-start;
		width: 100%;
    }
	.slider-container{
		position: relative;
		display: none;
		flex-direction: row;
		justify-content: center;
		width: 100%;
		height: 392px;
		margin: 0 auto;
		overflow: hidden;
		animation: fadeInUp 1s;
	}
	.slider-area{
		width: 1418px;
		margin: 0 auto;
		overflow: visible;
	}
	.slider-wrapper{
		position: relative;
		left: -2.2%;
		display: flex;
		flex-direction: row;
		width: 1418px;
		margin: 0 auto;
		transition: transform 0.1s ease-out; 
	}
	.review-card{
		flex: 0 0 16.66%; 
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		align-content: flex-start;
		justify-content: space-between;
		min-width: 338px;
		width: 338px;
		height: 360px;
		padding: 38px 31px;
		margin: 16px;
		flex-wrap: wrap;
		border-radius: 14px;
		background: #fff;
		box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.15);
		box-sizing: border-box;
	}
	.review-card:first-child, .review-card:last-child {
		width: 80%;
	}
    .d-title {
        display: none;
        font-weight: 600;
        font-size: 44px;
        line-height: 62px;
        color: #1A1A1A;
        animation: fadeInUp 1s;
    }
    .d-sub-title {
        display: none;
        margin-top: 28px;
        font-weight: 400;
        font-size: 18px;
        line-height: 32px;
        color: #666;
        animation: fadeInUp2 1.5s;
    }

	.soldoc-review .header-area{
		flex: 0 0 auto;
		display: flex;
		flex-direction: row;
		width: 100%;
		height: 80px;
	}
	.soldoc-review .title-area{
		width: calc(100% - 80px);
		margin-left: 16px;
	}
	.soldoc-review .category{
		font-size: 20px;
		font-weight: 600;
		line-height: 1;
		color: #000;
	}
	.soldoc-review .tag{
		display: inline-flex;
		justify-content: center;
		align-items: center;
		min-width: 71px;
		height: 30px;
		margin-top: 10px;
		padding: 0px 13px;
		gap: 10px;
		font-size: 14px;
		font-weight: 600;
		color: #333;
		text-align: center;
		border-radius: 6px;
	}
	
	.soldoc-review .tag01{
		background: #E3F5FF;
	}
	.soldoc-review .tag02{
		background: #FFDEAC;
	}
	.soldoc-review .tag03{
		background: #DCE2FF;
	}
	.soldoc-review .content-area{
		flex: 1 1 auto;
		margin-top: 29px;
		font-size: 18px;
		font-weight: 400;
		color: #666;
	}
	.soldoc-review .footer-area{
		flex: 0 0 auto;
		height: 16px;
		font-size: 16px;
		font-weight: 400;
		line-height: 1;
		color: #999;
	}

    .card-element {
        width: 315px;
        height: 380px;
        position: relative;
        display: inline-block;
        margin-right: 24px;
        transition: 1s;
        cursor: pointer;
    }
    .card-image {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 10px;
    }

    .left-arrow-btn {
        position: absolute;
        left: 0;
        top: 490px;
        z-index: 3;
        cursor: pointer;
    }

    .right-arrow-btn {
        position: absolute;
        right: 0;
        top: 490px;
        z-index: 999;
        cursor: pointer;
    }
    .department {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 32px;
        text-align: center;
        color: #999999;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        margin-top: 30px;
        z-index: 4;
    }
    .department-title {
        font-family: 'Pretendard';
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        text-align: center;
        color: #000000;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        margin-top: 59px;
        z-index: 4;
    }
     @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
    @keyframes fadeInUp2 {
        0% {
            opacity: 0;
            transform: translate3d(0, 130%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_main/SoldocReview.vue